<div class="gb-event-ticket-guest-form">
  <form [formGroup]="guestForm">
    <div class="form-container">
      <ng-container *ngIf="shouldShowSelfAssign">
        <mat-checkbox
          *ngIf="isAdminOrVolunteer; else isGuest"
          [checked]="isSelfAssigned"
          (change)="toggleIsSelfAssigned(eventTicket.purchaser)"
        >
          <span translate="SHARED.EVENT_TICKETS.FORM.ASSIGN_TO_PURCHASER"></span>
        </mat-checkbox>

        <ng-template #isGuest>
          <mat-checkbox
            *ngIf="selectedProfile$ | async as selectedProfile"
            [checked]="isSelfAssigned"
            (change)="toggleIsSelfAssigned(selectedProfile)"
          >
            <span translate="SHARED.EVENT_TICKETS.FORM.ASSIGN_TO_ME"></span>
          </mat-checkbox>
        </ng-template>
      </ng-container>

      <mat-form-field>
        <mat-label translate="SHARED.EVENT_TICKETS.FORM.FIRST_NAME"> </mat-label>
        <input matInput formControlName="first_name" name="first_name" />
        <mat-icon matSuffix>person</mat-icon>
      </mat-form-field>

      <mat-form-field>
        <mat-label translate="SHARED.EVENT_TICKETS.FORM.LAST_NAME"> </mat-label>
        <input matInput formControlName="last_name" name="last_name" />
        <mat-icon matSuffix>person</mat-icon>
      </mat-form-field>

      <mat-form-field>
        <mat-label translate="SHARED.EVENT_TICKETS.FORM.EMAIL"> </mat-label>
        <input matInput formControlName="email" name="email" type="email" />
        <mat-icon matSuffix>email</mat-icon>
      </mat-form-field>

      <mat-error *ngIf="emailFormControl?.hasError('emailMatch'); else inviteText">
        <span translate="SHARED.EVENT_TICKETS.FORM.EMAIL_MATCHES_PURCHASER_ERROR"></span>
        <span
          *ngIf="shouldShowSelfAssign"
          [translate]="
            isAdminOrVolunteer
              ? 'SHARED.EVENT_TICKETS.FORM.EMAIL_MATCHES_PURCHASER_ERROR_ASSIGN_TO_PURCHASER'
              : 'SHARED.EVENT_TICKETS.FORM.EMAIL_MATCHES_PURCHASER_ERROR_ASSIGN_TO_ME'
          "
        ></span>
      </mat-error>

      <ng-template #inviteText>
        <div *ngIf="shouldShowInviteEmailText" class="fade-in">
          <small
            translate="SHARED.EVENT_TICKETS.FORM.INVITE_EMAIL_INFO"
            [translateParams]="{ buttonLabel: buttonLabel | translate }"
          >
          </small>
        </div>
      </ng-template>

      <div *ngIf="shouldShowVerifyEmailText" class="fade-in">
        <gb-callout>
          <p translate="SHARED.EVENT_TICKETS.FORM.VERIFY_EMAIL_INFO"></p>
        </gb-callout>
      </div>

      <mat-form-field *ngIf="!!phoneFormControl">
        <mat-label translate="SHARED.EVENT_TICKETS.FORM.PHONE"> </mat-label>
        <gb-intl-phone-input
          formControlName="phone_number"
          [auctionCountryCode]="auctionCountry$ | async"
          name="phone_number"
        ></gb-intl-phone-input>
        <mat-icon matSuffix>phone</mat-icon>
      </mat-form-field>

      <ng-content select="[additionalFields]"> </ng-content>

      <ng-container
        *ngIf="shouldShowTableField && guestForm.get('table_number') && (allTableNumbers$ | async) as tableNumbers"
      >
        <mat-form-field *ngIf="tableNumbers.length > 0">
          <mat-label translate="SHARED.EVENT_TICKETS.FORM.TABLE"></mat-label>
          <mat-select matInput formControlName="table_number" name="table_number">
            <mat-option value="null">
              {{ 'SHARED.EVENT_TICKETS.FORM.NO_TABLE_OPTION' | translate }}
            </mat-option>
            <mat-option *ngFor="let tableNumber of tableNumbers" [value]="tableNumber.uuid">
              {{ tableNumber.table_number }}
            </mat-option>
          </mat-select>
          <mat-icon matSuffix>table_bar</mat-icon>
        </mat-form-field>
      </ng-container>
    </div>
    <ng-content></ng-content>
  </form>
</div>
